import { FC, RefObject } from "react";
import { Box } from "@otrium/core";
import { Checkbox } from "src/atoms/Checkbox";
import { HitType } from "src/types/Algolia";
import { useFilterApplied } from "src/organisms/AlgoliaProductList/useFilterApplied";
import {
  FilterContentWrapper,
  OutsideClickableWrapper,
  ScrollWrapper,
} from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/DesktopFilter.styled";
import { ShowResults } from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/ShowResults";

interface Props {
  items: HitType[];
  refine: (value: string[]) => void;
  outerRef: RefObject<HTMLDivElement>;
  onClose: () => void;
  isMultiColumn?: boolean;
}

const DefaultFilter: FC<Props> = ({
  items,
  onClose,
  isMultiColumn,
  refine,
  outerRef,
}) => {
  const { filterApplied, handleRefine } = useFilterApplied(items, refine);

  return (
    <OutsideClickableWrapper handler={onClose} outerRef={outerRef}>
      <ScrollWrapper>
        <FilterContentWrapper
          isMultiColumn={isMultiColumn && items.length > 1}
          as="ul"
          count={Math.round(items.length / 2)}
        >
          {items?.map((item, i) => {
            const label = item.label.split("||");
            const labelName = label[1];
            return (
              <Box as="li" key={`size-filter-item-${i}`}>
                <Checkbox
                  checked={item.isRefined}
                  onChange={handleRefine(item.value)}
                >
                  {labelName}
                </Checkbox>
              </Box>
            );
          })}
        </FilterContentWrapper>
      </ScrollWrapper>

      <ShowResults hasFilters={filterApplied} onClick={onClose} />
    </OutsideClickableWrapper>
  );
};

export default DefaultFilter;
